import React from 'react'
import './BgWithText.css'

export default function BgWithText({ image, data, height, positionX, positionY,noBGPosition }) {

  const dynamicClassName = noBGPosition ? 'bgWithText-image-no-bg-position' : 'bgWithText-image';
  return (
    <div>
      {/* image */}
      <div style={{ backgroundImage: `url(${image})`, height, backgroundPositionX: positionX, backgroundPositionY: positionY }} 
      className={dynamicClassName}>
        {/* overlay */}
        <div className="bgWithText-overlay" style={{ height }}>
          {/* text */}
          <div className="bgWithText__text_container">
            <p className="bgWithText__title">{data.title}</p>
            <p className="bgWithText__subtitle">{data.subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  )

}


